import { connect } from 'react-redux';
import { compose } from 'redux';
import { setKidsValidationState } from 'Store/faceting/facetingSearch.action';
import { endLoading } from 'Store/global-loader/globalLoader.action';
import { setDepartureCity } from 'Store/trip-criteria/departure-city/departureCity.action';
import { setDepartureDate } from 'Store/trip-criteria/departure-date/departureDate.action';
import { setDuration } from 'Store/trip-criteria/duration/duration.action';
import { getTripDuration } from 'Store/trip-criteria/tripCriteria.selector';
import { setAdultsNumber } from 'Store/trip-information/adults/adults.action';
import { resetKids, setKids } from 'Store/trip-information/kids/kids.action';
import { tripInformationSelector } from 'Store/trip-information/storeHelper';
import { BookingCriteria } from './BookingCriteria';
const mapDispatchToProps = {
  resetKids,
  setKidsValidationState,
  setAdultsNumber,
  setDepartureCity,
  setDepartureDate,
  setDuration,
  setKids,
  endLoading,
};

const mapStateToProps = (state: ReduxState) => ({
  tripInformation: tripInformationSelector(state as AppState),
  tripDurationCriteria: getTripDuration(state as AppState),
});

export const BookingCriteriaContainer = compose(
  connect(mapStateToProps, mapDispatchToProps, null, {
    forwardRef: true,
  }),
)(BookingCriteria);
